module.exports = __webpack_public_path__ + "9bc8e3cbdba9d5d63018246fe83f8b72.png";